export function checkRequired<Type>(v: Type, name: string): Type {
  if (v === undefined || v === null) {
    throw new Error(`${name} is required`);
  }
  return v;
}

export function checkCurrency(currency: string, name: string): string {
  if (!currency.match(/[a-zA-z]{3}/)) {
    throw new Error(`${name} is not a valid currency code: ${currency}`);
  }
  return currency;
}

export function checkAmount(amount: number, name: string): number {
  if (!(amount >= 0)) {
    throw new Error(`${name} is not a valid amount: ${amount}`);
  }
  return amount;
}

export function checkFunction<Type>(v: Type, name: string): Type {
  if (typeof v !== 'function') {
    throw new Error(`${name} is not a function: ${v}`);
  }
  return v;
}
